import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { ServiceDetail } from './pages/ServiceDetail';
import { Insights } from './pages/Insights';
import { InsightDetail } from './pages/InsightDetail';
import { Contact } from './pages/Contact';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
// Scroll to top on route change
const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="28u5ysp4wd9dw">
      <ScrollToTop data-id="element-1" data-mp="28tmi1bqzgr1g" />
      <div className="min-h-screen bg-brand-warm-white font-sans text-brand-charcoal selection:bg-brand-gold selection:text-white" data-id="element-2" data-mp="28suumo7jhzm9">
        <Navbar data-id="element-3" data-mp="23ti7e2craqj5" />
        <Routes data-id="element-4" data-mp="3ik7fqfdqo9q4">
          <Route path="/" element={<Home data-id="element-6" data-mp="3ij65gd4jrr9g" />} data-id="element-5" data-mp="3ikr0s4yore8d" />
          <Route path="/about" element={<About data-id="element-8" data-mp="3mlawd43m29se" />} data-id="element-7" data-mp="3ihv1odb3qjic" />
          <Route path="/services" element={<Services data-id="element-10" data-mp="3mjztd6hzp62c" />} data-id="element-9" data-mp="3mkrbpfmkt7ao" />
          <Route path="/services/:slug" element={<ServiceDetail data-id="element-12" data-mp="3rbzlwdvqcwow" />} data-id="element-11" data-mp="3mj6jvxrnc2gi" />
          <Route path="/insights" element={<Insights data-id="element-14" data-mp="3relwynhtxubv" />} data-id="element-13" data-mp="3rcswjpxt86cb" />
          <Route path="/insights/:slug" element={<InsightDetail data-id="element-16" data-mp="5ggje8nxyxz" />} data-id="element-15" data-mp="6hovayao7c0" />
          <Route path="/contact" element={<Contact data-id="element-18" data-mp="2zlli5ahfl0qy" />} data-id="element-17" data-mp="7stfczkdj46" />
          <Route path="/privacy" element={<Privacy data-id="element-20" data-mp="2zn6cayzu2hoa" />} data-id="element-19" data-mp="2zmeo498kfm81" />
          <Route path="/terms" element={<Terms data-id="element-22" data-mp="33nq73vwxp979" />} data-id="element-21" data-mp="33mf25srr5vek" />
        </Routes>
        <Footer data-id="element-23" data-mp="33oriy2lrxzq1" />
      </div>
    </BrowserRouter>;
}